import { Col, Form, Row, Button, DatePicker, Input } from "antd"
import React from "react"
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'
import S3Upload from '@a4b/ui/src/modules/monetisation/molecules/S3Upload'
import TextArea from "antd/lib/input/TextArea"

interface Props {
    fields: any
    add: () => void
    remove: (item: any) => void
    cdnUrl: string
    preSignUrl: string
}

const TempleCommittee: React.FC<Props> = ({ fields, add, remove, cdnUrl, preSignUrl, }) => {
    return (
        <>
            <Col span={32}>
                {fields.map((field: any, index: number) => {
                    return (
                        <div key={index} style={{
                            border: '1.5px solid #e0dcdc',
                            marginRight: '0px',
                            marginBottom: '10px',
                            width: '40vw',
                            padding: '10px',
                            gap: '5px'
                        }}>
                            <Col
                                style={{
                                    marginLeft: '3px',
                                    display: 'contents'
                                }}>
                                <Row style={{ width: '100%' }} justify="space-between">
                                    <Row>
                                        <Form.Item
                                            label={`Name ${index + 1}`}
                                            name={[field.name, 'name']}
                                        >
                                            <Input style={{ width: '220%' }} placeholder="Input name" />
                                        </Form.Item>
                                    </Row>
                                    <Row>

                                    </Row>

                                    <Button
                                        onClick={() => {
                                            remove(field.name)
                                        }}
                                        type='ghost'
                                        icon={<DeleteOutlined />}
                                        size='middle'
                                        danger
                                    ></Button>

                                </Row>
                                <Row>
                                    <Form.Item
                                        label={`Thumbnail ${index + 1}`}
                                        name={[field.name, 'thumbnail_img_url']}
                                        valuePropName='fileList'
                                        rules={[
                                            {
                                                required: false,
                                                min: 0,
                                                max: 1,
                                                validator: async (
                                                    rules: any,
                                                    values: any,
                                                ) => {
                                                    if (values?.length < rules.min) {
                                                        return Promise.reject(
                                                            'Please Upload thumbnail',
                                                        )
                                                    }
                                                },
                                            },
                                        ]}
                                    >
                                        <S3Upload
                                            cdnUrl={cdnUrl}
                                            preSignUrl={preSignUrl}
                                            min={1}
                                            max={1}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={`Image url ${index + 1}`}
                                        name={[field.name, 'image_url']}
                                        valuePropName='fileList'
                                        rules={[
                                            {
                                                required: false,
                                                min: 0,
                                                max: 1,
                                                validator: async (
                                                    rules: any,
                                                    values: any,
                                                ) => {
                                                    if (values?.length < rules.min) {
                                                        return Promise.reject(
                                                            'Please Upload Image',
                                                        )
                                                    }
                                                },
                                            },
                                        ]}
                                    >
                                        <S3Upload
                                            cdnUrl={cdnUrl}
                                            preSignUrl={preSignUrl}
                                            min={1}
                                            max={1}
                                        />
                                    </Form.Item>
                                </Row>
                                <Form.Item
                                    label={`Designation ${index + 1}`}
                                    name={[field.name, 'designation']}
                                    labelCol={{ span: 28 }}
                                    wrapperCol={{ span: 28 }}
                                    style={{ marginTop: '10px' }}
                                >
                                    <Input placeholder="Input designation" />
                                </Form.Item>
                                <Form.Item
                                    label={`Description ${index + 1}`}
                                    name={[field.name, 'description']}
                                    labelCol={{ span: 28 }}
                                    wrapperCol={{ span: 28 }}
                                    style={{ marginTop: '10px' }}
                                >
                                    <TextArea placeholder="Input description" />
                                </Form.Item>

                                <Col style={{ background: '#f5f5f5', padding: '10px', border: 'dotted', borderColor: '#8c8c8c' }}>
                                    <Form.Item
                                        label={`Facebook ${index + 1}`}
                                        name={[field.name, 'social_media', 'fb']}
                                        labelCol={{ span: 28 }}
                                        wrapperCol={{ span: 28 }}
                                        style={{ marginTop: '10px' }}
                                    >
                                        <Input placeholder="Input facebook url" />
                                    </Form.Item>
                                    <Form.Item
                                        label={`Instagram ${index + 1}`}
                                        name={[field.name, 'social_media', 'instagram']}
                                        labelCol={{ span: 28 }}
                                        wrapperCol={{ span: 28 }}
                                        style={{ marginTop: '10px' }}
                                    >
                                        <Input placeholder="Input instagram url" />
                                    </Form.Item>
                                    <Form.Item
                                        label={`Youtube ${index + 1}`}
                                        name={[field.name, 'social_media', 'youtube']}
                                        labelCol={{ span: 28 }}
                                        wrapperCol={{ span: 28 }}
                                        style={{ marginTop: '10px' }}
                                    >
                                        <Input placeholder="Input youtube url" />
                                    </Form.Item>
                                </Col>

                            </Col>
                        </div>
                    )
                })}
            </Col>
            <Col span={24} style={{ paddingTop: '10px' }}>
                <Row justify='start'>
                    <Col span={4}>
                        <Button
                            onClick={() => {
                                add()
                            }}
                            type='ghost'
                            icon={<PlusCircleOutlined />}
                            size='middle'
                        >
                            Add Temple committee info
                        </Button>
                    </Col>
                </Row>
            </Col>
        </>
    )
}

export default TempleCommittee